// extracted by mini-css-extract-plugin
export default {"Button":"CancelOverwrite_Button__iyoBP","ButtonLeft":"CancelOverwrite_ButtonLeft__HnhC3"};